import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Select from './Select';

// const TIME_REGEX = /^(10|11|12|[1-9]):[0-5][0-9]$/;

const HOUR_OPTIONS = [];
const MINUTE_OPTIONS = [];
for (let i = 0; i < 12; i++) {
	HOUR_OPTIONS.push({ value: i * 60, label: `${i === 0 ? '12' : i}` });
}
for (let i = 0; i < 60; i++) {
	MINUTE_OPTIONS.push({ value: i, label: `${i < 10 ? '0' + i : i}` });
}
const PERIOD_OPTIONS = [
	{ value: 0, label: 'am' },
	{ value: 720, label: 'pm' }
];


export default class TimeInput extends React.Component {
	static propTypes = {
		hour: PropTypes.string,
		minute: PropTypes.string,
		period: PropTypes.string,
		onChange: PropTypes.func.isRequired
	}

	constructor(props) {
		super(props);

		this.state = {
			hour: props.hour,
			minute: props.minute,
			period: props.period,
			hasError: false
		};
	}

	handleHourChange = ({ target }) => {
		const hour = target.value;
		this.setState({ hour });
		this.props.onChange({
			hour,
			minute: this.state.minute,
			period: this.state.period
		});
	}

	handleMinuteChange = ({ target }) => {
		const minute = target.value;
		this.setState({ minute });
		this.props.onChange({
			minute,
			hour: this.state.hour,
			period: this.state.period
		});
	}

	handlePeriodChange = ({ target }) => {
		const period = target.value;
		this.setState({ period });
		this.props.onChange({
			period,
			minute: this.state.minute,
			hour: this.state.hour
		});
	}

	render() {
		const { hour, minute, period, hasError } = this.state;
		return (
			<div className={cn('form-inline', { 'has-error': hasError })}>
				<Select
					options={HOUR_OPTIONS}
					selectedValue={hour}
					onChange={this.handleHourChange}
				/>:
				<Select
					options={MINUTE_OPTIONS}
					selectedValue={minute}
					onChange={this.handleMinuteChange}
				/>
				<Select
					options={PERIOD_OPTIONS}
					selectedValue={period}
					onChange={this.handlePeriodChange}
				/>
			</div>
		);
	}
}
